export default __webpack_public_path__ + "static/media/GM_Bowl_Fire.5ee8884e.png";